/**
 *
 * @param {Date} date
 * @param {number} seconds
 */
const secondsInPast = (date, seconds, log) => {
  const now = new Date();
  if (log) {
    console.log({ date: date });
    console.log({ now: now });
    console.log({ inPast: date.getTime() <= now.getTime() - seconds * 1000 });
    console.log({ 2: date.getTime() <= now.getTime() });
  }
  return date.getTime() <= now.getTime() - seconds * 1000;
};
const inDelayTime = (date, seconds, log) => {
  const now = new Date();
  if (log) {
    console.log({ date: date });
    console.log({ now: now });
    console.log({ inDelay: now.getTime() - date.getTime() <= seconds * 1000 });
    console.log({ datewat: date.getTime() });
    console.log({ nowwat: now.getTime() });
    console.log({ nowminus: now.getTime() - date.getTime() });
  }
  return now.getTime() - date.getTime() <= seconds * 1000;
};

/**
 *
 * @param {*} heat
 * @param {*} data
 * @param {number} seconds
 */
const parentHeatsInPast = (heat, data, seconds) => {
  let inPast = true;

  const roundOfHeat = data.find((round) => round.heats.find(({ id }) => id === heat.id));

  if (roundOfHeat && roundOfHeat.roundNr > 1) {
    const prevRound = data.find(({ roundNr }) => roundNr === roundOfHeat.roundNr - 1);

    const parentHeats = prevRound.heats.filter(
      ({ heatNr }) =>
        heatNr ===
          (roundOfHeat.type.toString().toLowerCase() === 'final' ? 1 : heat.heatNr) * 2 ||
        heatNr ===
          (roundOfHeat.type.toString().toLowerCase() === 'final' ? 1 : heat.heatNr) * 2 -
            1
    );

    for (let prevIndex = 0; prevIndex < parentHeats.length; prevIndex++) {
      if (
        !parentHeats[prevIndex].resultIsOfficial ||
        (parentHeats[prevIndex].resultIsOfficial &&
          !secondsInPast(
            new Date(parentHeats[prevIndex].resultIsOfficialTimestamp),
            seconds || 60
          ))
      ) {
        inPast = false;
        break;
      }
    }
  }

  return inPast;
};

export { secondsInPast, parentHeatsInPast, inDelayTime };
